var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg070Forward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6399 4.28995C17.2478 3.90059 16.6143 3.90283 16.2249 4.29495C15.8356 4.68707 15.8378 5.32059 16.2299 5.70995L19.5699 8.99995H9.42993C5.84008 8.99995 2.92993 11.9101 2.92993 15.5C2.92993 19.0898 5.84008 22 9.42993 22H11.9399C12.4922 22 12.9399 21.5522 12.9399 21C12.9399 20.4477 12.4922 20 11.9399 20H9.42993C6.94465 20 4.92993 17.9852 4.92993 15.5C4.92993 13.0147 6.94465 11 9.42993 11H19.5599L16.2399 14.27C15.8522 14.66 15.8522 15.2899 16.2399 15.68C16.427 15.8708 16.6827 15.9788 16.9499 15.98C17.2123 15.9788 17.4637 15.8747 17.6499 15.69L22.7099 10.69C22.8923 10.5062 22.9962 10.2588 22.9999 9.99995C22.9988 9.73271 22.8908 9.47702 22.6999 9.28995L17.6399 4.28995Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg070Forward);
export default __webpack_public_path__ + "static/media/070-forward.a6ed3ca1a067054d7bc5afbee52ea474.svg";
export { ForwardRef as ReactComponent };